import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { useIsOwner, useSessionPermission } from '@btime/react-session'
import { useMemo } from 'react'

import { useModalData } from '../../../../../components/modals/ModalsContext'
import { useNavigation } from '../../../../../utils/contexts/NavigationContext'
import { useOpenEditTriggerModal } from '../../../../../utils/routes/modals/modalsActions'
import { useRemoveTriggers } from '../../_requests/remove'

export const useRowsActions = item => {
  const { entities } = useModalData() || {}
  const isOwner = useIsOwner()
  const canCreate = useSessionPermission('createTrigger')
  const canEdit = useSessionPermission('editTrigger')
  const canDelete = useSessionPermission('deleteTrigger')

  const navigate = useNavigation()

  const [deleteItems, { loading }] = useRemoveTriggers()
  const openEditModal = useOpenEditTriggerModal()

  const singleOptions = useMemo(
    () => [
      ...appendIf(isOwner, {
        value: 'logs',
        icon: 'RiTimeLine',
        onClick: () => navigate(`/logs?entityTriggerIds=${item.id}`),
        to: `/logs?entityTriggerIds=${item?.id}`
      }),

      ...appendIf(canEdit && !item.readOnly, {
        value: 'edit',
        icon: 'BsPencil',
        onClick: () => openEditModal({ id: item.id, entities })
      }),

      ...appendIf(canCreate && !item.readOnly, {
        value: 'clone',
        icon: 'BsLayers',
        onClick: () => openEditModal({ cloneFromId: item.id, entities })
      }),

      ...appendIf(canDelete, {
        value: 'remove',
        color: COLORS.red,
        icon: 'BsTrash',
        onClick: () => deleteItems([item.id])
      })
    ],
    [item, canDelete, canEdit, deleteItems, navigate]
  )

  return [singleOptions, loading]
}
